export default __webpack_public_path__ + "static/media/compu-negro@2x.9b3cab54.png";